import { LinkBehaviour, NestedLink } from '@/graphql/gql/graphql';
import Image from '@/components/Image';
import { filterEmpty } from '@/utils/index';
import Link from 'next/link';
import { NAV_LINK_CLICKED } from '@/constants/amplitude';
import { useAmplitude } from '@/utils/hooks/useAmplitude';
import ArrowDown from '@/components/svg/ArrowDown';
import ArrowUp from '@/components/svg/ArrowUp';
import Styles from './MobileMenuItem.module.scss';

type MobileMenuItemProps = NestedLink & {
  setActive: (sport:string)=> void, activeSport?:string, index:number };

const MobileMenuItem = ({
  text, iconUrl, children, setActive, activeSport, index,
}:MobileMenuItemProps) => {
  const { logAmplitudeEvent } = useAmplitude();
  return (
    <li className={Styles.container}>
      <div onKeyDown={() => {}} role="button" tabIndex={index} onClick={() => setActive(text)}>
        <Image alt={`${text} icon`} src={iconUrl ?? ''} height={16} width={16} />
        { text }
        <div className={Styles.arrowContainer}>
          {activeSport === text ? <ArrowUp color="#1381E0" /> : <ArrowDown color="#1381E0" />}
        </div>
      </div>
      {activeSport === text ? (
        <ul className={Styles.submenu}>
          {filterEmpty(children ?? []).map((child) => (
            <li key={child.text}>
              <Link
                target={child?.behaviour === LinkBehaviour.NewWindow ? '_blank' : '_self'}
                href={child.url}
                onClick={() => {
                  logAmplitudeEvent(
                    NAV_LINK_CLICKED,
                    {
                      'Link Text': child.text,
                      'Link URL': child.url,
                      Module: 'navigation_menu',
                      Menu: activeSport,
                    },
                  );
                }}
              >
                {child.text}
              </Link>
            </li>
          ))}
        </ul>
      ) : ''}
    </li>
  );
};

export default MobileMenuItem;
